export default __webpack_public_path__ + "static/media/main-logo-removed.b4f8ba33.png";